import AppRouter from "./router/AppRouter";
import "./App.css";
import { Provider } from "react-redux";
import { persistor, store } from "./app/store";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import { PersistGate } from "redux-persist/integration/react";
import "../src/styles/globals.css"

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <PrimeReactProvider>
          <PersistGate loading={null} persistor={persistor}>
            <AppRouter />
          </PersistGate>
        </PrimeReactProvider>
      </Provider>
    </div>
  );
}

export default App;
